import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Popover, PopoverInteractionKind, Position } from '@blueprintjs/core';
import UserMenuPopover from './UserMenuPopover';
import ListsMenuPopOver from './ListsMenuPopOver';
import ReportsMenuPopOver from './ReportsMenuPopOver';
import './NavbarMobile.css';
import UmpirePic from './../assets/baseball-umpire.png';
import phbaLogo from './../assets/PHBA-Blue-Crew-Logo.png';


class NavbarDesktop extends Component {
  changeSelectedSeason = event => {
    if (event.target.value) {
      this.props.changeUserSeason(event.target.value);
    }
  }

  getUserInit = (userName) => {
    if (userName) {
      const spaceIndex = userName.indexOf(' ');
      return userName.charAt(0) + (((spaceIndex > 0) && (userName.length > spaceIndex)) ? userName.charAt(spaceIndex + 1) : '');
    }
    return '';
  }

  render() {
    const { userSeason, handleLogout, history, location, match, userName, userType, seasons, seasonsList } = this.props;
    const userInit = this.getUserInit(userName);

    return (
      <nav className="pt-navbar pt-fixed-top">
        <div className="pt-navbar-group pt-align-left">
          <div className="pt-navbar-heading">
            <Link to="/">
              <img src={phbaLogo} height="40" width="auto" alt="Blue Crew Logo" />
            </Link>
          </div>
        </div>

        <div className="pt-navbar-group pt-align-right">
          <div className="pt-navbar-heading">
            <label className="pt-label pt-inline">
              Season:
              <select
                className="pt-input"
                id="season"
                value={userSeason}
                onChange={this.changeSelectedSeason}
              >
                {seasonsList.map(seasonId => (
                  <option key={seasonId} value={seasonId}>
                    {seasons[seasonId].name}
                  </option>
                ))}
              </select>
            </label>
          </div>
          <span className="pt-navbar-divider" />
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {userType === 'Admin' && (
              <Popover
                content={<ListsMenuPopOver history={history} location={location} match={match} />}
                interactionKind={PopoverInteractionKind.CLICK}
                position={Position.BOTTOM}
              >
                <button className="pt-button pt-minimal">Lists</button>
              </Popover>
            )}
            <Popover
              content={<ReportsMenuPopOver history={history} location={location} match={match} userType={userType} />}
              interactionKind={PopoverInteractionKind.CLICK}
              position={Position.BOTTOM}
            >
              <button className="pt-button pt-minimal">Reports</button>
            </Popover>
            {userType === 'Admin' && (
                <Link to="/sms-message">
                  <button className="pt-button pt-minimal">Notifications</button>
                </Link>
            )}
          </div>
          <img src={UmpirePic} height="40" width="auto" alt="Blue Crew Logo" />
          <Popover
            content={<UserMenuPopover handleLogout={handleLogout} location={location} history={history} match={match} />}
            interactionKind={PopoverInteractionKind.CLICK}
            position={Position.BOTTOM_RIGHT}
          >
            <button className="pt-button pt-minimal" data-test="user-menu-btn">
              {`${userInit}`}
              <span className="pt-icon-standard pt-icon-chevron-down" />
            </button>
          </Popover>
        </div>
      </nav>
    );
  }
}

export default NavbarDesktop;



// WEBPACK FOOTER //
// ./src/components/NavbarDesktop.js